<div class="container container-shadow mb-5 pb-4">
  <div class="row" *ngIf="appointment_request">
    <div class="col-12">
      <div class="page-header">
        <div class="float-left">
          <a [routerLink]="'/appointment_requests/'" class="btn btn-link">Go to Appointment Requests</a>
        </div>
        <div class="clearfix"></div>
        <h4 class="text-center">
          <strong
            ><a [href]="'/matters/' + appointment_request.matter.id">{{ appointment_request.matter.number }}</a
            >&nbsp;- {{ appointment_request.matter.name }}</strong
          >
        </h4>
        <h4 class="text-center">
          <strong>Appointment Request #{{ appointment_request.id }}</strong>
        </h4>
      </div>
      <div class="row">
        <div class="col-sm-2 col-md-2 d-none d-sm-block"></div>
        <div class="col-12 col-sm-8 col-md-8">
          <table class="table">
            <tbody>
              <tr>
                <td colspan="2">
                  <div *ngIf="appointment_request.editing_allowed_while_checked_out">
                    <a *ngIf="attorney || tech" [routerLink]="'/appointment_requests/' + this.appointment_request.id + '/edit'" class="btn btn-primary btn-sm">Edit</a>
                    <button type="button" *ngIf="appointment_request.cancelled" (click)="reinstateAppointmentRequest()" class="btn btn-default btn-sm">Reinstate</button>
                    <button type="button" (click)="cancelAppointmentRequest()" *ngIf="!appointment_request.cancelled" class="btn btn-danger btn-sm">Cancel</button>
                    <button type="button" class="btn btn-warning btn-sm" (click)="releaseCheckOut()">Release Check out</button>
                  </div>
                  <div *ngIf="!appointment_request.editing_allowed_while_checked_out">
                    <button type="button" class="btn btn-primary btn-sm" (click)="checkOutAppointmentRequest()">Check out</button>
                  </div>
                  <br />
                  <div *ngIf="appointment_request.cancelled">
                    <span class="text-danger p-1 mt-1">This appointment request has been cancelled.</span>
                  </div>
                  <div *ngIf="appointment_request.scheduled">
                    <span class="text-success p-1 mt-1">This appointment request has been scheduled.</span>&nbsp;
                    <a [href]="'/events/' + appointment_request.event_id">View Event</a>
                  </div>
                  <div *ngIf="!appointment_request.checked_out">
                    <span class="bg-warning p-1 mt-1">Not checked_out.</span>
                  </div>
                  <div *ngIf="!appointment_request.editing_allowed_while_checked_out && appointment_request.checked_out">
                    <span class="bg-info text-white p-1 mt-1">Checked out by {{ appointment_request.checked_out_by_name }} at {{ appointment_request.checked_out_on }}.</span>
                  </div>
                  <div *ngIf="appointment_request.editing_allowed_while_checked_out">
                    <span class="bg-info text-white p-1 mt-1">Checked out by me.</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Requested By</th>
                <td>{{ appointment_request.requested_by }}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>
                  <p class="bg-primary text-white py-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.type }}</p>
                </td>
              </tr>
              <tr>
                <th>Appointment Location</th>
                <td>
                  <div *ngIf="appointment_request.location.highlight">
                    <p class="bg-danger text-white py-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.name }}</p>
                  </div>
                  <div *ngIf="!appointment_request.location.highlight">
                    <p class="bg-info text-white py-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.name }}</p>
                    <p class="bg-success text-white py-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.address }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>How Soon Needed</th>
                <td>
                  <p [ngClass]="{ 'bg-warning py-1': appointment_request.how_soon == 'ASAP', 'text-danger': appointment_request.how_soon == 'Delay 1 Hour', 'text-info': appointment_request.how_soon == 'Whenever Convenient' }" style="padding-left: 5px; padding-right: 5px">
                    {{ appointment_request.how_soon_needed }}
                  </p>
                </td>
              </tr>
              <tr>
                <th>Requested On</th>
                <td>{{ appointment_request.requested_on }}</td>
              </tr>
              <tr>
                <th>Requested Length</th>
                <td>{{ appointment_request.requested_length }}</td>
              </tr>
              <tr>
                <th>Attendees</th>
                <td>
                  <ul class="list-group">
                    <li class="list-group-item" *ngFor="let attendee of appointment_request.attendees">
                      <strong>{{ attendee.name }}</strong>
                      <br />
                      <div style="padding-left: 10px" *ngFor="let phone_number of attendee.phone_numbers">
                        <strong>{{ phone_number.phone_type_name }}:&nbsp;</strong>
                        <a appPhoneCallBilling [phoneCallContactName]="attendee.name || ''" [href]="'tel:' + phone_number.number" title="Call {{ phone_number.number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ phone_number.number }}</a>
                      </div>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>Initial Notes</th>
                <td>{{ appointment_request.initial_notes }}</td>
              </tr>
              <tr>
                <th>Ongoing Notes</th>
                <td>
                  <div *ngIf="appointment_request.editing_allowed_while_checked_out">
                    <button type="button" class="btn btn-primary btn-sm" (click)="editingOngoingNote = !editingOngoingNote" *ngIf="!editingOngoingNote">Edit</button>
                    <div *ngIf="editingOngoingNote">
                      <div style="border: 1px solid #ccc">
                        <app-tinymce [initialContent]="appointment_request.ongoing_notes" [elementId]="'ongoing-notes-editor'" (onEditorKeyup)="appointment_request.notes = $event"></app-tinymce>
                      </div>
                      <div class="text-center" style="padding-top: 5px">
                        <button type="button" class="btn btn-primary btn-sm" (click)="saveNote()">Save Note</button>
                        <button type="button" class="btn btn-default btn-sm" (click)="editingOngoingNote = !editingOngoingNote">Cancel</button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="appointment_request.ongoing_notes && !editingOngoingNote" [innerHTML]="appointment_request.ongoing_notes"></div>
                  <div *ngIf="!appointment_request.ongoing_notes && !editingOngoingNote">No Notes entered.</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button type="button" *ngIf="appointment_request.editing_allowed_while_checked_out" class="btn btn-link" (click)="showAppointmentRequestResultForm = !showAppointmentRequestResultForm"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp;New Result</button>
          <div *ngIf="showAppointmentRequestResultForm">
            <app-appointment-request-result-form
              [eventType]="appointment_request.type"
              [attendees]="appointment_request.attendees"
              [formOptions]="appointment_request_result_form_options"
              [appointmentRequestId]="appointment_request.id"
              (formSaved)="onAppointmentRequestResultSave($event)"
            ></app-appointment-request-result-form>
          </div>
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h5 class="panel-title">Contact Results - {{ appointment_request.appointment_request_results.length }}</h5>
            </div>
            <table class="table" *ngIf="appointment_request.appointment_request_results.length > 0">
              <thead>
                <tr>
                  <th style="font-weight: bold">When and By Who</th>
                  <th style="font-weight: bold">Attempted Contact With</th>
                  <th style="font-weight: bold">Result/Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let appointment_request_result of appointment_request.appointment_request_results">
                  <td *ngIf="!appointment_request_result.editing">
                    <strong>Created By:&nbsp;</strong>
                    {{ appointment_request_result.created_by }}&nbsp; on&nbsp;
                    {{ appointment_request_result.created_at }}
                    <span *ngIf="appointment_request_result.updated_by">
                      <br />
                      <strong>Updated By:&nbsp;</strong>
                      {{ appointment_request_result.updated_by }}&nbsp; on&nbsp;
                      {{ appointment_request_result.updated_at }}
                    </span>
                    <span>
                      <br />
                      <button (click)="appointment_request_result.editing = true" *ngIf="appointment_request.editing_allowed_while_checked_out && !appointment_request_result.send_result_chosen" type="button" class="btn btn-sm btn-link">Edit</button>
                      <button type="button" (click)="emailResult(appointment_request_result)" class="btn btn-sm btn-link" [disabled]="appointment_request_result.emailing_to_attorney">
                        <span *ngIf="appointment_request_result.emailing_to_attorney">
                          <span>Processing email</span>&nbsp;
                          <i class="fas fa-spinner fa-pulse fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </span>
                        <span *ngIf="!appointment_request_result.emailing_to_attorney">
                          <span>Email to Attorney</span>
                        </span>
                      </button>
                    </span>
                  </td>
                  <td *ngIf="!appointment_request_result.editing" [innerHTML]="attemptedContactWith(appointment_request_result)"></td>
                  <td *ngIf="!appointment_request_result.editing" [innerHTML]="resultNotes(appointment_request_result)"></td>
                  <td colspan="3" *ngIf="appointment_request_result.editing">
                    <app-appointment-request-result-form
                      [eventType]="appointment_request.type"
                      [attendees]="appointment_request.attendees"
                      [formOptions]="appointment_request_result_form_options"
                      [appointmentRequestId]="appointment_request.id"
                      [appointmentRequestResult]="appointment_request_result"
                      (formSaved)="onAppointmentRequestResultSave($event, appointment_request_result)"
                    ></app-appointment-request-result-form>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!appointment_request">
    <div class="col-12 text-center">
      <br />
      <br />
      <br />
      <i class="fas fa-spinner fa-pulse fa-5x fa-fw"></i>
      <span class="sr-only">Loading...</span>
      <br />
      <br />
      <br />
    </div>
  </div>
</div>
